/**
 * Pagination.tsx — wrapper rundt @carbon/react Pagination
 *
 * Beholder vår eksisterende API (currentPage, totalPages, totalItems, pageSize)
 * men bruker Carbon Pagination internt.
 *
 * Bruk:
 *   <Pagination currentPage={1} totalPages={5} totalItems={47} pageSize={10} onPageChange={setPage} />
 */

import { Pagination as CarbonPagination } from '@carbon/react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  /** Totalt antall elementer — viser «X–Y av Z elementer» når satt */
  totalItems?: number;
  /** Elementer per side — brukes sammen med totalItems */
  pageSize?: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  // Carbon Pagination krever totalItems + pageSize for å vise «X–Y av Z»
  // Hvis ikke oppgitt, bruk totalPages som fallback (viser kun sidetall)
  const effectiveTotalItems = totalItems ?? totalPages * (pageSize ?? 1);
  const effectivePageSize = pageSize ?? 1;

  return (
    <CarbonPagination
      page={currentPage}
      pageSize={effectivePageSize}
      totalItems={effectiveTotalItems}
      onChange={({ page }) => onPageChange(page)}
      backwardText="Forrige side"
      forwardText="Neste side"
      itemsPerPageText="Elementer per side:"
    />
  );
}
